export var PlanType;
(function (PlanType) {
    PlanType["Starter"] = "starter";
    PlanType["Wizard"] = "wizard";
    PlanType["Dashboard"] = "dashboard";
    PlanType["Seal"] = "seal";
})(PlanType || (PlanType = {}));
//# sourceMappingURL=types.js.map